import * as React from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetTinyDeclarationsRepoType, IGetTinyDeclarationsRepo } from '../../repos';

export const useTinyDeclarationTableContext = () => {
  const getTinyDeclarationsRepo = useService<IGetTinyDeclarationsRepo>(GetTinyDeclarationsRepoType);

  const handleFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getTinyDeclarationsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getTinyDeclarationsRepo],
  );

  return { handleFetch };
};
